module.exports = __webpack_public_path__ + "static/media/admin.76ae9a94.svg";